export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'c4ffe738-0b78-4a78-a1c2-21b39b6b9ef5';
export const MODAL_CLOSE_SEC = 2.5;
